import { default as React, useContext } from "react";
import styled from "styled-components";
import { IComponent } from "../components/Component";
import {
  Vertical,
  VerticalDI,
  verticalDI,
  VerticalSpec,
} from "../components/Vertical";
import { PageContext } from "../PageContext";
import headerImage from "../../assets/headerimage_001.png";
import { Container } from "react-bootstrap";

export const PAGE_HOME = "page_home";
export interface PageHomeSpec {
  type: typeof PAGE_HOME;
  content: VerticalSpec;
  headerImageURL?: string; // Optional custom header image URL
}

const ContentContainer = styled.div`
  // Simplified styles since we're using the main LWZO navbar and styles
  width: 100%;
  flex: 1 1 auto;
`;

const EditButtonContainer = styled.div`
  position: absolute;
  z-index: 1000;
  right: 30px;
  top: 110px;
  @media (max-width: 1096px) {
    display: none;
  }
`;

const EditButton = styled.button`
  background-color: blue;
  color: white;
  border-width: 0;
  outline: none;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6);
  text-align: center;
  text-decoration: none;
  display: inline-block;
  width: 100px;
  height: 30px;
`;

export const PageHomeRender = (props: VerticalDI<PageHomeSpec>) => {
  const VerticalDIComp = props.Vertical;
  const { canEdit, setEditing, isEditing } = useContext(PageContext);

  return (
    <Container className="mb-4">
      <EditButtonContainer>
        {canEdit && !isEditing ? (
          <EditButton onClick={() => setEditing(true)}>Editieren</EditButton>
        ) : null}
      </EditButtonContainer>
      <ContentContainer>
        <div
          className="w-100 position-relative mb-4"
          style={{ height: "300px" }}
        >
          <img
            src={props.spec.headerImageURL || headerImage}
            alt="LWZO Header"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              position: "absolute",
            }}
          />
        </div>
        <VerticalDIComp spec={props.spec.content} />
      </ContentContainer>
    </Container>
  );
};

export const PageHome: IComponent<PageHomeSpec> = {
  component: verticalDI(PageHomeRender, Vertical),
};
